module.exports = __webpack_public_path__ + "static/media/fortboyard.35a78dde.jpg";